<tile 
    title="{{ 'online_presence' | translate }}" 
    subtitle="{{ 'total_links_built' | translate }}" 
    val="{{totalLinksBuilt | undefinedNumber | formatNumber }}" 
    icon="link" 
    change="{{mtdLinksBuild}}"
    [showChange]="showChange"
    help="{{ 'online_presence_help' | translate }}">
</tile>
